module.exports = __webpack_public_path__ + "img/241226b.8b2e66e4.jpg";